import * as Scrivito from "scrivito";
import { localizeAttrList } from "^/utils/localizeAttribute";
import mapsWidgetIcon from "../../assets/images/maps_widget.svg";

Scrivito.provideEditingConfig("OpenStreetMapWidget", {
  title: "OpenStreetMap",
  thumbnail: mapsWidgetIcon,
  attributes: localizeAttrList(
    ["markers", "showWidgets"],
    "OpenStreetMapWidget"
  ),
  properties: ["markers", "showWidgets"],
  initialContent: {
    showWidgets: "no",
    zoom: 13,
  },
});
